module.exports = __webpack_public_path__ + "media/images/icon__betPick--pick-bbed10c5347b6ab8b350a04e443cd117.png";